import { useSelector, shallowEqual } from 'react-redux';
import PhoneNumberuserInfo from './PhoneNumberuserInfo';

const HandlePhoneNumber = () => {
  const { address, phoneNumber, schedule, workType } = useSelector(
    (state) => ({
      address: state.form.address,
      phoneNumber: state.form.phoneNumber,
      schedule: state.form.schedule,
      workType: state.form.workType,
    }),
    shallowEqual
  );

  return (
    <>
      <PhoneNumberuserInfo
        address={address}
        phoneNumber={phoneNumber}
        schedule={schedule}
        workType={workType}
      />
    </>
  );
};

export default HandlePhoneNumber;
